var amt_admin = require('amt_admin').default;
var app = require("angular").module("ww2_analytics.video", [amt_admin]);

app.service("video_api", [
  "jsonrpc",
  function(jsonrpc) {
    var service = jsonrpc.newService("video");
    this.video_count = service.createMethod("video_count");
    this.avg_video_count_per_mission = service.createMethod('avg_video_count_per_mission');
    this.video_count_growing = service.createMethod('video_count_growing');
    this.video_count_growing_by_missions = service.createMethod('video_count_growing_by_missions');
    this.video_count_growing_by_installs = service.createMethod('video_count_growing_by_installs');
    this.video_count_growing_with_coefs = service.createMethod('video_count_growing_with_coefs');
    this.video_count_total = service.createMethod('video_count_total');
  }
]);

app.config([
  "$stateProvider",
  function($stateProvider) {
    $stateProvider
    .state("amt.ww2.video", {
        url: "/video",
        template: "<div ui-view></div>",
        reloadOnSearch: false,
        abstract: true,
        data: {
          priority: 900,
          title: "Video",
          role: "video",
        },
        menu: {
          glyphicon: "facetime-video",
          childs: [
            {
              state: "amt.ww2.video.total",
              glyphicon: "facetime-video",
            },
            {
              state: "amt.ww2.video.per_feature",
              glyphicon: "facetime-video",
            },
            {
              state: "amt.ww2.video.per_mission",
              glyphicon: "facetime-video",
            },
            {
              state: "amt.ww2.video.per_day_in_game",
              glyphicon: "facetime-video",
            },
            {
              state: "amt.ww2.video.per_day_in_game_growing",
              glyphicon: "facetime-video",
            },
            {
              state: "amt.ww2.video.per_day_in_game_growing_by_installs",
              glyphicon: "facetime-video",
            },
            {
              state: "amt.ww2.video.per_mission_growing",
              glyphicon: "facetime-video",
            },
            {
              state: "amt.ww2.video.per_day_in_game_growing_with_coefs",
              glyphicon: "facetime-video",
            },
            {
              state: "amt.ww2.video.per_day_in_game_total",
              glyphicon: "facetime-video",
            },
            {
              state: "amt.ww2.video.histograms",
              glyphicon: "facetime-video",
            },
            {
              state: "amt.ww2.video.usage_by_dau",
              glyphicon: "facetime-video",
            },
          ],
        },
      })
    .state("amt.ww2.video.total", require('./total').default)
    .state("amt.ww2.video.histograms", require('./histograms').default)
    .state("amt.ww2.video.per_feature", require('./per_feature').default)
    .state("amt.ww2.video.per_mission", require('./per_mission').default)
    .state("amt.ww2.video.per_day_in_game", require('./per_day_in_game').default)
    .state("amt.ww2.video.per_day_in_game_growing", require('./per_day_in_game_growing').default)
    .state("amt.ww2.video.per_day_in_game_growing_by_installs", require('./per_day_in_game_growing_by_installs').default)
    .state("amt.ww2.video.per_mission_growing", require('./per_mission_growing').default)
    .state("amt.ww2.video.per_day_in_game_growing_with_coefs", require('./per_day_in_game_growing_with_coefs').default)
    .state("amt.ww2.video.per_day_in_game_total", require('./per_day_in_game_total').default)
    .state("amt.ww2.video.usage_by_dau", require('./usage_by_dau').default)
  }
]);

export default app.name;
